import React from "react";

export default function YearToYearProductsSalesBarFilter({
  yearToYearFilter,
  handleChangeProductType,
  products,
  handleChangeInput = () => {},
  getData = () => {},
  type = "machines",
}) {
  return (
    <div className="rounded pt-1">
      <div className="row mt-3">
        <div className="col-lg-6 col-md-6 col-sm-12 d-flex justify-content-around">
          <div className="d-flex justify-content-center align-items-center justify-content-around mr-2">
            <div className="form-check mr-2 d-flex align-items-center">
              <input
                className="mr-2"
                type="radio"
                name={`productTypeYearToYear-${type}`}
                id={`productTypeAllYearToYear-${type}`}
                value=""
                checked={!yearToYearFilter.productType}
                onChange={handleChangeProductType}
              />
              <label
                className="form-check-label"
                htmlFor={`productTypeAllYearToYear-${type}`}
              >
                Razem
              </label>
            </div>
            <div className="form-check mr-2 d-flex align-items-center">
              <input
                className="mr-2"
                type="radio"
                name={`productTypeYearToYear-${type}`}
                id={`productTypeCardYearToYear-${type}`}
                value="1"
                checked={yearToYearFilter.productType == "1"}
                onChange={handleChangeProductType}
              />
              <label
                className="form-check-label"
                htmlFor={`productTypeCardYearToYear-${type}`}
              >
                Snack
              </label>
            </div>
            <div className="form-check mr-2 d-flex align-items-center">
              <input
                className="mr-2"
                type="radio"
                name={`productTypeYearToYear-${type}`}
                id={`productTypeCashYearToYear-${type}`}
                value="2"
                checked={yearToYearFilter.productType === "2"}
                onChange={handleChangeProductType}
              />
              <label
                className="form-check-label"
                htmlFor={`productTypeCashYearToYear-${type}`}
              >
                Kawa
              </label>
            </div>
          </div>
        </div>
        <div className="col-lg-6 col-md-12 col-sm-12 ">
          <div className="d-flex justify-content-lg-end justify-content-md-center h-100 align-items-center">
            {/* <div className="w-25"> */}
            <div className="input-group input-group-sm w-lg-50">
              <input
                className="form-control"
                placeholder="Produkt"
                list="products"
                name="productName"
                onChange={handleChangeInput}
                autoComplete="off"
                defaultValue={yearToYearFilter.productName}
                onFocus={(e) => {
                  e.target.value = "";
                  handleChangeInput(e);
                }}
                onBlur={(e) => !e.target.value && getData()}
              />
              <datalist id="products">
                {products &&
                  products.map((product, idx) => (
                    <option
                      value={`${product.Name} (${product.EAN})`}
                      key={idx}
                    />
                  ))}
              </datalist>
              <button
                className="card btn-sm ml-2 fas fa-redo mr-2"
                style={{
                  backgroundColor: "#0140BE",
                  color: "white",
                  height: "2rem",
                }}
                onClick={getData}
              ></button>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
